import { axiosApi } from "../../../api/dbAxios";
import { IUsedDocIds } from "../interfaces/FilterState";

export const exportDataFiles = async (
  usedIds: IUsedDocIds[],
  format: string,
  onlyFavorite: boolean,
) => {
  const body = {
    records: usedIds,
    format,
    only_favorite: onlyFavorite,
  };
  try {
    const response = await axiosApi.post(`/export/`, body, {
      responseType: "arraybuffer",
    });

    return response;
  } catch (error) {
    console.error("Error exporting files:", error);
    throw error;
  }
};
